const INTERNAL_GLOBAL_SETTING_SERVICE_DATA_MANAGEMENT_MENU = {
  title: "Service",
  icon: "FolderPlusIcon",
  route: "serviceManagement",
}

const INTERNAL_GLOBAL_SETTING_TICKET_DATA_MANAGEMENT_MENU = {
  title: "Ticket",
  icon: "TagIcon",
  isActive: true,
  children: [
    {
      title: "Ticket Topic",
      route: "addTicketTopicData",
    },
    {
      title: "Reply Template",
      route: "addTicketReplyTemplateData",
    },
  ],
}

const INTERNAL_GLOBAL_SETTING_LOCATION_DATA_MANAGEMENT_MENU = {
  title: "Location",
  icon: "MapPinIcon",
  route: "locationManagement",
}

export {
  INTERNAL_GLOBAL_SETTING_SERVICE_DATA_MANAGEMENT_MENU,
  INTERNAL_GLOBAL_SETTING_TICKET_DATA_MANAGEMENT_MENU,
  INTERNAL_GLOBAL_SETTING_LOCATION_DATA_MANAGEMENT_MENU,
}
